export const warehouseContants = {
  GET_ALL_WAREHOUSE: "GET_ALL_WAREHOUSE",
};
